import { render, staticRenderFns } from "./ContestBanner.vue?vue&type=template&id=54818cdc&scoped=true&"
import script from "./ContestBanner.vue?vue&type=script&lang=js&"
export * from "./ContestBanner.vue?vue&type=script&lang=js&"
import style0 from "./ContestBanner.vue?vue&type=style&index=0&id=54818cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54818cdc",
  null
  
)

export default component.exports